export const TAROT_CORPUS_VERSION = '0.3.0';
export const TAROT_CORPUS_GENERATED_AT = '2026-04-01T00:00:00.000Z';
